import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Layers, MessageSquareQuote, Image as ImageIcon, Users2, Mails, TrendingUp } from "lucide-react";

const cards = [
  { key: "quotes_total", label: "Total de orçamentos", icon: Mails, accent: "red" },
  { key: "quotes_new", label: "Novos aguardando", icon: TrendingUp, accent: "blue" },
  { key: "simulators_total", label: "Simuladores", icon: Layers, accent: "red" },
  { key: "testimonials_total", label: "Depoimentos", icon: MessageSquareQuote, accent: "blue" },
  { key: "gallery_total", label: "Itens da galeria", icon: ImageIcon, accent: "red" },
  { key: "clients_total", label: "Clientes", icon: Users2, accent: "blue" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  const [quotes, setQuotes] = useState([]);

  useEffect(() => {
    (async () => {
      const [s, q] = await Promise.all([api.get("/admin/stats"), api.get("/admin/quotes")]);
      setStats(s.data);
      setQuotes(q.data.slice(0, 5));
    })();
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <div className="overline text-neutral-500 mb-2">Painel</div>
        <h1 className="font-display font-black text-3xl">Dashboard</h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => (
          <div key={c.key} className="relative overflow-hidden rounded-xl border border-white/5 bg-[#0a0a0a] p-6" data-testid={`stat-card-${c.key}`}>
            <div className={`absolute -top-10 -right-10 w-32 h-32 rounded-full blur-[60px] opacity-30 ${c.accent === "blue" ? "bg-[#008CFF]" : "bg-[#E31B23]"}`} />
            <div className={`relative w-10 h-10 rounded-lg flex items-center justify-center mb-4 ${c.accent === "blue" ? "bg-[#008CFF]/10 text-[#008CFF]" : "bg-[#E31B23]/10 text-[#E31B23]"}`}>
              <c.icon className="w-5 h-5" />
            </div>
            <div className="text-neutral-400 text-xs uppercase tracking-widest">{c.label}</div>
            <div className="mt-2 font-display font-black text-3xl">{stats[c.key] ?? 0}</div>
          </div>
        ))}
      </div>

      <div className="mt-10">
        <h2 className="font-display font-bold text-lg mb-4">Últimos orçamentos</h2>
        <div className="rounded-xl border border-white/5 bg-[#0a0a0a] overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-white/5 text-neutral-400 uppercase text-xs tracking-widest">
              <tr>
                <th className="text-left p-4">Nome</th>
                <th className="text-left p-4">Cidade</th>
                <th className="text-left p-4">Tipo</th>
                <th className="text-left p-4">Data envio</th>
              </tr>
            </thead>
            <tbody>
              {quotes.length === 0 && (
                <tr><td colSpan={4} className="p-8 text-center text-neutral-500">Nenhum orçamento ainda.</td></tr>
              )}
              {quotes.map((q) => (
                <tr key={q.id} className="border-t border-white/5">
                  <td className="p-4"><div className="font-semibold text-white">{q.name}</div><div className="text-xs text-neutral-500">{q.email}</div></td>
                  <td className="p-4">{q.city}</td>
                  <td className="p-4">{q.event_type || "-"}</td>
                  <td className="p-4">{new Date(q.created_at).toLocaleString("pt-BR")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
